/* kora-cro.js — kora MD homepage interactivity
 * Vanilla JS, no framework, no build step.
 *
 * The homepage is split into independent Shopify sections, so this file may be
 * referenced by more than one <script> tag. The guard below makes initialization
 * idempotent (it runs exactly once) and waits for the full DOM so it can see
 * elements in every section regardless of which one loaded the script first.
 */
(() => {
  'use strict';

  if (window.__koraCroHomeInit) return;
  window.__koraCroHomeInit = true;

  const init = () => {
    // ── Auto-stagger: promote children of [data-stagger] to .reveal ──
    // Any parent with data-stagger gets each of its direct children turned into
    // a revealable element with a sequential --i, so the row fades in card-by-card.
    // Children that already have an --i keep it; index restarts at 0 per parent.
    document.querySelectorAll('[data-stagger]').forEach((row) => {
      Array.from(row.children).forEach((child, idx) => {
        child.classList.add('reveal');
        if (!child.style.getPropertyValue('--i')) {
          child.style.setProperty('--i', String(idx));
        }
      });
    });

    // ── Reveals (IntersectionObserver) ─────────────────────────
    const revealEls = document.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && revealEls.length) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach((el) => io.observe(el));
    } else {
      revealEls.forEach((el) => el.classList.add('is-visible'));
    }

    // ── Mobile nav: close on link click ────────────────────────
    const navToggle = document.getElementById('navToggle');
    if (navToggle) {
      document.querySelectorAll('.nav__menu a').forEach((a) => {
        a.addEventListener('click', () => { navToggle.checked = false; });
      });
    }

    // ── Report pills selection (visual only) ───────────────────
    document.querySelectorAll('.report__pills .pill').forEach((p) => {
      p.addEventListener('click', () => {
        p.parentElement.querySelectorAll('.pill').forEach((s) => s.classList.remove('is-active'));
        p.classList.add('is-active');
      });
    });

    // ── FAQ: only one open at a time ───────────────────────────
    document.querySelectorAll('.faq details').forEach((d) => {
      d.addEventListener('toggle', () => {
        if (d.open) {
          document.querySelectorAll('.faq details').forEach((o) => { if (o !== d) o.open = false; });
        }
      });
    });

    // ── Sticky-shell shadow on scroll ──────────────────────────
    const shell = document.getElementById('stickyShell');
    if (shell) {
      const onScroll = () => {
        shell.classList.toggle('is-scrolled', window.scrollY > 4);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
